import styled from "styled-components";

export const GalleryContainer = styled.div`
  position: relative;
  padding-top: 50px;

  &::before {
    position: absolute;
    content: " ";
    background-color: #7b6e661a;
    height: 85%;
    width: 100%;
    top: 0px;
  }

  @media only screen and (max-width: 768px) {
    &::before {
      height: calc(100% + 20px);
    }
  }
`;

export const TitleWrap = styled.div`
  position: relative;
  margin-bottom: 100px;
  @media only screen and (max-width: 768px) {
    margin-bottom: 50px;
  }
`;

export const ImageContainer = styled.div`
  position: absolute;
  top: -30px;
  left: 0px;
  width: 80%;
  left: 10%;
  opacity: 0.2;

  @media only screen and (max-width: 768px) {
    top: 30px;
  }
`;
